<template>
  <div class="rules">
    <div class="model" @click="close"></div>
    <div class="content">
      <div class="desc" v-for="(item,index) in strArr" :key="index">
        <span>{{item}}</span>。
      </div>
      <div class="backButton" @click.stop="goBackNormal">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rules',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      strArr: [],
    };
  },
  mounted() {
    this.initStr();
  },
  methods: {
    initStr() {
      this.strArr = this.text.split('。');
      this.strArr.length -= 1;
    },
    close() {
      this.$emit('close');
    },
    goBackNormal() {
      this.close();
    },
  },
};
</script>
<style scoped lang="scss">
.rules {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .model {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: 0.7;
    z-index: 9;
  }
  .content {
    width:80%;
    z-index:9;
    background: #fff4da;
    position: absolute;
    text-align:center;
    width:halvePx(600);
    height: auto;
    padding:halvePx(20) 0;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    border-radius: halvePx(10);
    .desc{
      width:100%;
      padding:0 halvePx(40);
      line-height: halvePx(50);
      text-align:left;
      font-size:halvePx(30);
      font-family:PingFang-SC-Medium;
      font-weight:500;
    }
    .backButton{
      width:halvePx(540);
      height:halvePx(100);
      line-height:halvePx(100);
      text-align:center;
      background:#7DB9FF;
      border-radius:halvePx(50);
      font-size:halvePx(30);
      font-family:PingFang-SC-Medium;
      font-weight:500;
      color:rgba(255,255,255,1);
      margin:halvePx(20) auto;
    }
  }
}
</style>
